

// SAR Config
export const accelerationFactor = 0.02;
export const maxAccelerationFactor = 0.2;

export const theme = {
  greenMint: '#40944e',
  redDesire: '#d62323',
  greenNeon: '#25bb2e',
  redChilli: '#d62323',
  redHot: '#FF0000',
  mehroon2: '#F9ACAA',
  mehroon1: '#6A3126',
  mehroon: '#6A1B19',
  green1: '#A2F5BF',
  green: '#0B4228',
  green2: '#00421B',
  skyBlue: '#4286f4',
  skyBlue1: '#6fa4fc',
  skyBlue2: '#b5d0ff',
};

//Volume Graph(Area)
export const volumeAppearance = {
  stroke: '#7aa4ea70',
  fill: '#9dbaec70',
};

// Axis
export const axisAppearance = {
  // stroke: theme.axis,
  // fill: theme.axis,
  // tickStroke: theme.axis,
};

// Bollinger Band
export const bbStroke = {
  top: '#964B00',
  middle: '#000000',
  bottom: '#964B00',
};

export const bbFill = theme.skyBlue;

// MACD
export const macdAppearance = {
  strokeStyle: {
    macd: "#FF0000",
    signal: "#00F300",
    zero: '#FF0000'
  },
  fillStyle: {
    divergence: "#4682B4"
  },
};

// ATR
export const atrAppearance = {
  stroke: theme.greenMint,
};

// Axis
export const edgeIndicatorAppearance = {
  strokeOpacity: 1,
  strokeWidth: 1,
  arrowWidth: 0,
};

export const stoAppearance = {
  stroke: {
    top: '#964B00',
    middle: '#000000',
    bottom: '#964B00',
    dLine: '#EA2BFF',
    kLine: '#74D400',
  },
};

// Mouse
export const mouseEdgeAppearance = {
  textFill: "#542605",
  stroke: "#05233B",
  strokeOpacity: 1,
  strokeWidth: 3,
  arrowWidth: 5,
  fill: "#BCDEFA",
};

